import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import ProductsService from "../service/productsService";
import {useEffect, useState} from "react";
import {toast} from "sonner";


export function useProducts(id) {

    const [products, setProducts] = useState([])

    const queryClient = useQueryClient();

    const {data: productsData} = useQuery({
        queryKey:["products", id],
        queryFn: ()=> ProductsService.getAllSub(id),
    })

    const {mutate: deleteProduct} = useMutation({
        mutationKey: "deleteProduct",
        mutationFn: (id)=> ProductsService.delete(id),
        onSuccess: () => {
            toast.success("Товар удален")
            queryClient.invalidateQueries("products");
        },
        onError: () => toast.error("Не удалось удалить товар")
    })

    const {mutate: update} = useMutation({
        mutationKey: ["catalogsUpdate"],
        mutationFn: async (data) => await ProductsService.update(data),
        onSuccess: () => {
            toast.success("Товар обновлен")
            queryClient.invalidateQueries({queryKey: ['products']})
        },
    })

    const {mutate: create} = useMutation({
        mutationKey: ["createProduct"],
        mutationFn: async (data) => await ProductsService.create(data),
        onSuccess: () => {
            toast.success("Товар успешно создан")
            queryClient.invalidateQueries({queryKey: ['products']})
        },
    })

    const {mutate: updateOrder} = useMutation({
        mutationKey: ["updateOrder"],
        mutationFn: async (orders) => {
            await ProductsService.updateOrder(orders)
        },
        onSuccess: () => {
            toast.success("Товар перемещен")
            queryClient.invalidateQueries({queryKey: ['products']})
        }
    })

    useEffect(() => {
        setProducts(productsData || [])
    }, [productsData])

    return {
        products,
        deleteProduct,
        updateOrder,
        update,
        create
    }
}